import React, {ReactElement} from "react";
import style from "./style.less";
import Typography from "../Typography";
import {TypographyTypes} from "../Typography/Typography";
import Badge from "../Badge";
import {BadgeType} from "../Badge/Badge";
import Icon from "../Icon/Icon";
import Progression from "../Progression";
import {ProgressEntry} from "../../services/api/elearningapi";

interface ElearningRowProps {
  title: string | React.ReactNode
  progress: ProgressEntry
}


const ElearningProgressRow: React.FunctionComponent<ElearningRowProps> = ({
  title,
  progress,
}): ReactElement => {
  let badgeType = BadgeType.red
  if (progress.progress > 0.80) {
    badgeType = BadgeType.green
  } else if (progress.progress > 0.50) {
    badgeType = BadgeType.yellow
  }

  return (
    <div className={style.topicContainer}>
      <div className={style.topic}>
        <Typography type={TypographyTypes.body}>{title}</Typography>
        {progress && (
          <div className={style.topicData}>
            <Badge
              type={badgeType}
              label={`${progress.progress * 100}%`}
              icon={<Icon name={'Star'} />}
            ></Badge>
          </div>
        )}
      </div>
      {progress.progress !== undefined && (
        <Progression percent={progress.progress * 100} />
      )}
    </div>
  )
}

export default ElearningProgressRow
